// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: stale-schedule protection — sanitizeSelectedSchedule,
// resyncScheduleIfStale, bindStaleScheduleResync — at ang checkout-click
// validation guard (bindCheckoutValidation), na parehong resync muna bago
// mag-validate.
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const state = DP.state;

  function sanitizeSelectedSchedule() {
    const { dateInput, timeHidden } = state.elements;
    if (!dateInput) return false;

    let hasChanged = false;
    const now = DP.getNowPH();

    if (dateInput.value && !DP.isDateSelectable(dateInput.value, now)) {
      dateInput.value = "";
      if (timeHidden) timeHidden.value = "";
      hasChanged = true;
    } else if (
      dateInput.value &&
      timeHidden &&
      timeHidden.value &&
      !DP.isSlotAvailable(dateInput.value, timeHidden.value, now)
    ) {
      timeHidden.value = "";
      hasChanged = true;
    }

    if (hasChanged && state.fpInstance) {
      state.fpInstance.setDate(dateInput.value || null, false);
    }

    return hasChanged;
  }

  // Hakbang 3 (2026-09-02): ang state.availability window mismo (hindi lang
  // ang napiling date/time) ay pwedeng maging luma — dalawang paraan:
  //   1. lumipas na ang araw sa Asia/Manila kaysa sa window.today (midnight
  //      rollover habang bukas ang tab).
  //   2. lumagpas na ang window.cutoffAt pero minDate === today pa rin sa
  //      window — ibig sabihin hindi pa na-advance ng server ang window
  //      papuntang bukas, kaya kailangang i-refetch para malaman.
  // Kapag hindi stale, sapat na ang parehong window para sa minute-tick
  // re-render — ang lastOrderAt comparison ay laban sa Date.now() mismo.
  function isScheduleStale(now = DP.getNowPH()) {
    const availability = state.availability;
    if (!availability) return false;

    if (now.format("YYYY-MM-DD") !== availability.today) return true;

    if (availability.minDate === availability.today) {
      const cutoffMs = Date.parse(availability.cutoffAt);
      if (Number.isFinite(cutoffMs) && Date.now() >= cutoffMs) return true;
    }

    return false;
  }

  function resyncScheduleIfStale() {
    const { dateInput } = state.elements;

    // Fire-and-forget: ang checkout-click validation (bindCheckoutValidation
    // sa ibaba) ay dapat manatiling synchronous, walang await dito.
    // Magre-render ulit ang refreshScheduleRules() mismo pagdating ng bagong
    // window.
    if (isScheduleStale()) {
      void DP.refreshScheduleRules();
    }

    const scheduleChanged = sanitizeSelectedSchedule();

    DP.renderCountdown();

    if (scheduleChanged) {
      DP.renderDateStrip();
      DP.renderTimeSlots(dateInput && dateInput.value ? dateInput.value : null, true);
      DP.syncSelectorDisplays();
      void DP.updateCart(DP.buildCartPayload(), "stale-resync");
    }

    return scheduleChanged;
  }

  function bindCheckoutValidation() {
    const { checkoutBtns, dateInput, timeHidden } = state.elements;

    checkoutBtns.forEach((btn) => {
      if (btn.dataset.deliveryValidationBound) return;

      btn.addEventListener("click", (e) => {
        if (state.scheduleLoadFailed) {
          e.preventDefault();
          DP.showScheduleLoadError();
          DP.scrollErrorIntoView();
          return;
        }

        resyncScheduleIfStale();

        if (!dateInput || !dateInput.value || !timeHidden || !timeHidden.value) {
          e.preventDefault();
          DP.toggleError("Please select delivery date and time.");
          DP.scrollErrorIntoView();
        }
      });

      btn.dataset.deliveryValidationBound = "true";
    });
  }

  // Order #4114 (2026-08-15): a customer can leave the /cart tab open
  // across a staleness boundary (midnight rollover, same-day cutoff) and
  // tap one of the dynamic/express checkout buttons that Shopify renders
  // into `additional_checkout_buttons` (sections/main-cart-footer.liquid,
  // GCash/Maya/etc via the `content_for_additional_checkout_buttons` block)
  // instead of the plain Checkout button. Those buttons are Shopify-owned
  // (often iframed) — bindCheckoutValidation() has no way to attach a
  // click guard to them. Re-sanitizing whenever the tab regains focus
  // corrects the DOM + cart attributes BEFORE any checkout button, dynamic
  // or plain, can be tapped.
  function bindStaleScheduleResync() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") resyncScheduleIfStale();
    });
    window.addEventListener("pageshow", () => resyncScheduleIfStale());
  }

  DP.sanitizeSelectedSchedule = sanitizeSelectedSchedule;
  DP.isScheduleStale = isScheduleStale;
  DP.bindCheckoutValidation = bindCheckoutValidation;
  DP.bindStaleScheduleResync = bindStaleScheduleResync;
})();
